<template>
  <v-dialog
    v-model="Mostrar"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    persistent
    max-width="900px"
    :overlay="false"
    justify-center
    transition="dialog-transition"
  >
    <v-card>
      <loading
        :active.sync="loading"
        background-color="#C5CAE9"
        color="#1A237E"
        :is-full-page="false"
      ></loading>
      <v-toolbar color="blue darken-3" dark flat>
        <v-toolbar-title>
          <span class="font-awesome display-1 ml-5">{{
            canEdit ? title : "Información del Insumo"
          }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="$emit('Close')" icon>
          <v-icon size="30">mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-flex>
        <v-stepper v-model="insumos">
          <v-stepper-header>
            <v-stepper-step editable step="1"
              >Información general</v-stepper-step
            >
            <v-divider vertical inset></v-divider>
            <v-stepper-step editable step="2">Unidades</v-stepper-step>
            <v-divider vertical inset></v-divider>
            <v-stepper-step editable step="3">Adicionales</v-stepper-step>
          </v-stepper-header>

          <v-stepper-content step="1">
            <v-card>
              <!-- <v-card-title primary-title v-if="$vuetify.breakpoint.smAndDown"
                >title</v-card-title
              > -->
              <v-layout row wrap>
                <v-col cols="10" sm="4">
                  <v-text-field
                    name="codigo"
                    label="Código"
                    v-model="codigo"
                    @blur="ValidateCode()"
                    @input="$v.codigo.$touch()"
                    :error-messages="codigoErrors"
                    counter
                    prepend-inner-icon="mdi-clipboard-list"
                    maxlength="20"
                    :readonly="!canEdit"
                    autocomplete="off"
                  >
                    <template v-slot:append-outer>
                      <v-tooltip bottom color="indigo darken-3" max-width="200">
                        <template v-slot:activator="{ on }">
                          <v-icon color="indigo darken-3" v-on="on"
                            >mdi-help-circle</v-icon
                          >
                        </template>
                        <span
                          >Código para identificar al Insumso en su
                          Catálogo</span
                        >
                      </v-tooltip>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="10" sm="4">
                  <v-text-field
                    name="barcode"
                    label="Código de barras"
                    v-model="codigoBarras"
                    counter
                    maxlength="20"
                    @blur="$v.codigoBarras.$touch()"
                    @input="$v.codigoBarras.$touch()"
                    :error-messages="codigoBarrasErrors"
                    prepend-inner-icon="mdi-barcode"
                    :readonly="!canEdit"
                    autocomplete="off"
                  ></v-text-field>
                </v-col>

                <v-col cols="10" sm="7">
                  <template>
                    <v-expansion-panels color="grey lighten-4">
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          <template v-slot:default="{ open }">
                            <v-row no-gutters>
                              <v-col>
                                <v-text-field
                                  name="nombre"
                                  label="Nombre de insumo"
                                  v-model="nombre"
                                  @blur="$v.nombre.$touch()"
                                  @input="$v.nombre.$touch()"
                                  :error-messages="nombreErrors"
                                  class="mt-n6"
                                  prepend-inner-icon="mdi-package-variant-closed"
                                  :readonly="!canEdit"
                                  autocomplete="off"
                                ></v-text-field>
                              </v-col>
                            </v-row>
                          </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="mt-n9">
                          <v-container grid-list-xs>
                            <v-row>
                              <v-col cols="10" md="8">
                                <v-text-field
                                  v-model="ShortName"
                                  @blur="$v.ShortName.$touch()"
                                  @input="$v.ShortName.$touch()"
                                  :error-messages="ShortNameErrors"
                                  maxlength="50"
                                  counter
                                  label="Nombre corto"
                                  :readonly="!canEdit"
                                  autocomplete="off"
                                ></v-text-field>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </template>
                </v-col>
                <v-col cols="10" sm="2">
                  <v-text-field
                    name="existenicaminima"
                    label="Existencia mínima"
                    v-model="ExistMin"
                    @blur="$v.ExistMin.$touch()"
                    @input="$v.ExistMin.$touch()"
                    :error-messages="ExistMinErrors"
                    @keypress="keypressevent"
                    :readonly="!canEdit"
                    autocomplete="off"
                  >
                    <template v-slot:append>
                      <v-tooltip bottom color="indigo darken-3" max-width="200">
                        <template v-slot:activator="{ on }">
                          <v-icon color="indigo darken-3" v-on="on"
                            >mdi-help-circle</v-icon
                          >
                        </template>
                        <span>Existencia mínima para el insumo</span>
                      </v-tooltip>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="10" sm="2">
                  <v-text-field
                    name="existenciamaxima"
                    label="Existenica máxima"
                    v-model="ExistMax"
                    @blur="$v.ExistMax.$touch()"
                    @input="$v.ExistMax.$touch()"
                    :error-messages="ExistMaxErrors"
                    @keypress="keypressevent"
                    :readonly="!canEdit"
                    autocomplete="off"
                  ></v-text-field>
                </v-col>
                <v-col cols="10" md="12">
                  <v-select
                    :items="Providers"
                    @blur="$v.ProviderId.$touch()"
                    @input="$v.ProviderId.$touch()"
                    :error-messages="ProviderIdErrors"
                    dense
                    item-text="name"
                    item-value="id"
                    v-model="ProviderId"
                    label="Proveedor"
                    :readonly="!canEdit"
                    autocomplete="off"
                  >
                    <template v-slot:append-outer v-if="canEdit">
                      <v-tooltip max-width="200" bottom color="blue darken-3">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            @click="AddProvider()"
                            v-on="on"
                            icon
                            small
                            color="blue darken-3"
                          >
                            <v-icon size="25">mdi-pencil-plus-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>Agregar nuevo Proveedor</span>
                      </v-tooltip>
                    </template>
                  </v-select>
                </v-col>
              </v-layout>
            </v-card>
          </v-stepper-content>
          <v-stepper-content step="2">
            <v-card style="margin: 2px">
              <v-card-title v-if="$vuetify.breakpoint.smAndDown"
                >Unidades de Conversion</v-card-title
              >
              <v-row no-gutters>
                <v-col cols="10" sm="4" md="3" lg="3" class="ml-4">
                  <v-select
                    label="Unidad de compra"
                    item-text="name"
                    color="blue darken-4"
                    class="compra"
                    outlined
                    dense
                    return-object
                    v-model="UnidadC"
                    @input="$v.UnidadC.$touch()"
                    @keypress="onlyForCurrency"
                    :error-messages="UnidadCErrors"
                    :items="unidades"
                    :readonly="!canEdit"
                    autocomplete="off"
                  ></v-select>
                </v-col>
                <v-col cols="10" sm="4" md="3" lg="3" class="ml-4">
                  <v-select
                    label="Unidad de Almacen"
                    item-text="name"
                    color="green accent-4"
                    class="almacen"
                    outlined
                    dense
                    return-object
                    v-model="UnidadA"
                    @keypress="onlyForCurrency"
                    :items="unidades"
                    :readonly="!canEdit"
                    autocomplete="off"
                  ></v-select>
                </v-col>
                <v-col cols="10" sm="4" md="3" lg="3" class="ml-4">
                  <v-select
                    label="Unidades de Uso"
                    item-text="name"
                    color="red accent-4"
                    class="uso"
                    outlined
                    dense
                    return-object
                    @keypress="onlyForCurrency"
                    v-model="UnidadU"
                    :items="unidades"
                    :readonly="!canEdit"
                    autocomplete="off"
                  >
                    <template v-slot:append-outer v-if="canEdit">
                      <v-tooltip max-width="200" bottom color="blue darken-3">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            @click="addUnit = true"
                            v-on="on"
                            icon
                            small
                            color="blue darken-3 ml-4"
                          >
                            <v-icon size="25">mdi-pencil-plus-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>Agregar nueva Unidad</span>
                      </v-tooltip>
                    </template>
                  </v-select>
                </v-col>
                <!-- <v-col cols="12" sm="3" md="3" lg="3"></v-col> -->
              </v-row>
              <v-divider></v-divider>
              <v-row class="mt-n5">
                <v-card>
                  <v-card-title>
                    <span class="font-weight-bold grey--text"
                      >Conversiones</span
                    >
                  </v-card-title>
                </v-card>
                <v-card-text>
                  <v-row no-gutters class="d-flex align-center">
                    <v-col cols="12" sm="auto">
                      <span class="font-weight-bold indigo--text"
                        >1 [ {{ UnidadesCompra }} ]</span
                      >
                    </v-col>
                    <v-col cols="12" sm="2" md="2" lg="2" class="ml-3">
                      <v-text-field
                        name="name"
                        label="Cantidad"
                        id="id"
                        class="almacenInput"
                        dense
                        @keypress="KeyEventPress"
                        single-line
                        v-model="buyToStockFactor"
                        :suffix="UnidadesAlmacen"
                        :readonly="!canEdit"
                        autocomplete="off"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row no-gutters class="d-flex align-center">
                    <v-col cols="12" sm="auto">
                      <span class="font-weight-bold green--text">
                        {{ buyToStockFactor }}
                        <span class="font-weight-bold green--text"
                          >[ {{ UnidadesAlmacen }} ]</span
                        >
                      </span>
                      Contiene
                    </v-col>

                    <v-col cols="12" sm="2" md="2" lg="2" class="ml-3">
                      <v-text-field
                        name="name"
                        label="Cantidad"
                        id="id"
                        class="usoInput"
                        dense
                        @keypress="KeyEventPress"
                        single-line
                        v-model="stockToUseFactor"
                        :suffix="UnidadesUso"
                        :readonly="!canEdit"
                        autocomplete="off"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-row>
            </v-card>
          </v-stepper-content>
          <v-stepper-content step="3">
            <v-flex>
              <v-layout row wrap>
                <v-col cols="10" sm="5">
                  <div class="h6 font-weight-medium">
                    ¿ Siempre se adquiere al mismo proveedor ?
                  </div>
                </v-col>
                <v-col cols="5" sm="2">
                  <v-switch
                    class="mt-n2"
                    color="indigo accent-4"
                    inset
                    :label="Swtprov == true ? 'Si' : 'No'"
                    v-model="Swtprov"
                    :readonly="!canEdit"
                    :disabled="!canEdit"
                    autocomplete="off"
                  ></v-switch>
                </v-col>
              </v-layout>
              <v-layout row>
                <v-col cols="10" sm="3">
                  <div class="h6 font-weight-medium">
                    ¿ Es un insumo preparado ?
                  </div>
                </v-col>
                <v-col cols="5" sm="1">
                  <v-switch
                    class="mt-n2"
                    color="indigo accent-4"
                    inset
                    :label="Swtprep == true ? 'Si' : 'No'"
                    v-model="Swtprep"
                    :readonly="!canEdit"
                    :disabled="!canEdit"
                    autocomplete="off"
                  ></v-switch>
                </v-col>
              </v-layout>
              <v-layout row wrap>
                <v-flex>
                  <receta
                    v-if="Swtprep"
                    @Receta="Receta"
                    :SupplieId="SupplieId"
                    :productBom="supplieBoms"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
          </v-stepper-content>
        </v-stepper>
      </v-flex>
      <v-snackbar
        v-model="snackbar"
        top
        :timeout="5000"
        :color="color"
        multi-line
        >{{ text }}</v-snackbar
      >

      <v-card-actions class="pl-0">
        <div class="flex-grow-1"></div>
        <v-btn
          v-if="insumos == 3 && canEdit"
          @click="Guardar"
          color="green darken-4"
          min-width="100"
          >Guardar</v-btn
        >
        <v-btn @click="Validate()" v-if="insumos != 3" outlined color="primary"
          >Siguiente</v-btn
        >
        <v-btn @click="$emit('Close')" v-else color="red darken-4"
          >Cerrar</v-btn
        >
      </v-card-actions>
      <modal-proveedores
        :canEdit="canEdit"
        :dialog="addProvider"
        @Close="addProvider = false"
        :edited="false"
        @Guardar="SaveProv"
        :EditedItem="EditedIte"
        :loadingD="loadingD"
      />
      <modal-unidad
        :canEdit="canEdit"
        :dialog="addUnit"
        @close="addUnit = false"
        @Guardar="SaveUnit"
      ></modal-unidad>
    </v-card>
  </v-dialog>
</template>
<style scoped>
.compra >>> fieldset {
  border-color: #0d47a1 !important;
}
.compra >>> label {
  color: #0d47a1 !important;
}
.almacen >>> fieldset {
  border-color: #00c853 !important;
}
.almacen >>> label {
  color: #00c853 !important;
}
.almacenInput {
  color: #00c853 !important;
}
.uso >>> fieldset {
  border-color: #d50000 !important;
}
.uso >>> label {
  color: #d50000 !important;
}
.usoInput {
  color: #d50000 !important;
}
</style>
<script>
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import axios from "axios";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Swal from "sweetalert2";
import _ from "lodash";
export default {
  mixins: [validationMixin],
  validations: {
    codigo: { required },
    nombre: { required },
    ShortName: { required },
    ExistMin: { required },
    ExistMax: { required },
    ProviderId: {},
    UnidadC: { required },
    codigoBarras: { maxLength: maxLength(20) },
  },
  components: {
    Receta: () => import("../../Componentes/Receta"),
    ModalProveedores: () => import("../../Componentes/Modals/proveedores"),
    ModalUnidad: () => import("../../Componentes/Modals/unidades"),
    Loading,
  },
  watch: {
    nombre(val) {
      if (val != null) {
        this.ShortName = val;
      }
    },
    UnidadC(val) {
      if (val != null) {
        this.UnidadesCompra = val.name;
      }
    },
    UnidadA(val) {
      if (val != null) {
        this.UnidadesAlmacen = val.name;
      }
    },
    UnidadU(val) {
      if (val != null) {
        this.UnidadesUso = val.name;
      }
    },
    dialog(val) {
      if(!val){
        this.$v.$reset();
        this.insumos = 1;
        this.codigo = null;
        this.codigoBarras = null;
        this.nombre = null;
        this.ShortName = null;
        this.ProviderId = null;
        this.ExistMin = 0;
        this.ExistMax = 0;
        this.UnidadC = null;
        this.UnidadA = null;
        this.UnidadU = null;
        this.buyToStockFactor = null;
        this.stockToUseFactor = null;
        this.supplieBoms = [];
        this.Swtprov = false;
      }
    },
  },
  data() {
    return {
      addUnit: false,
      SupplieId: 0,
      EditedIte: Array(),
      loadingD: false,
      addProvider: false,
      insumos: 1,
      ProviderId: null,
      codigo: null,
      codigoBarras: null,
      nombre: null,
      proveedor: null,
      ExistMin: 0,
      ExistMax: 0,
      UnidadC: null,
      UnidadA: null,
      UnidadU: null,
      ConverUno: null,
      ConverDos: null,
      InsumoPrepa: false,
      MismoProv: false,
      UnidadesCompra: null,
      UnidadesAlmacen: null,
      UnidadesUso: null,
      MostrarProv: false,
      Swtprov: false,
      Swtprep: false,
      ShortName: null,
      buyToStockFactor: null,
      stockToUseFactor: null,
      supplieBoms: [],
      Receta_: [],
      Providers: [],
      snackbar: false,
      color: "",
      text: "",
      unidades: [],
    };
  },
  methods: {
    ValidateCode() {
      this.$v.codigo.$touch();

      if (!this.$v.codigo.$error) {
        const val = this.$v.codigo.$model;
        const find = _.find(this._getInsumos, { code: val });
        if (find) {
          this.snackbar = true;
          this.color = "red";
          this.text = `El código ${val}  ya ha sido registrado`;
          this.codigo = "";
          this.$v.codigo.$touch();
        }
      }
    },
    KeyEventPress($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      }
    },
    LoadUnidades() {
      axios
        .get("/api/Catalogs/Unit", {
          headers: {
            bussinessId: this.$store.state._bussinessAccountId,
          },
        })
        .then((result) => {
          return result.data;
        })
        .then((data) => {
          //  this.desserts = data;
          this.unidades = data;
          // this.$store.commit("SET_CAT_UNIDADES", data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    SaveUnit(values) {
      axios
        .post(
          "/api/Catalogs/Unit",
          {
            name: values.name,
            alias: values.alias,
            satCode: values.satCode,
          },
          {
            headers: {
              bussinessId: this.$store.state._bussinessAccountId,
            },
          }
        )
        .then((result) => {
          return result.data;
        })
        .then((data) => {
          this.addUnit = false;

          this.snackbar = true;
          this.timeout = 2000;
          this.color = "#388E3C";
          this.text = "Registro exitoso.";
          this.LoadUnidades();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    LaodProviders() {
      axios
        .get("/api/Provider", {
          headers: {
            bussinessId: localStorage.getItem("_bussinessAccountId"),
          },
        })
        .then((result) => {
          this.Providers = result.data;
        })
        .catch((err) => {
          Swal.fire(
            "OOops",
            "Algo Salio mal al obtener los datos de los proveedores",
            "error"
          );
        });
    },
    SaveProv(Values) {
      let RFC = Values.rfc;
      this.loadingD = true;
      axios
        .post(
          "/api/Provider",
          {
            name: Values.name,
            rfc: RFC.toUpperCase(),
            Country: Values.Country,
            city: Values.city,
            stateId: Values.stateId,
            street: Values.street,
            zipCode: Values.zipCode,
            extNumber: Values.extNumber,
            intNumber: Values.intNumber,
            observations: Values.observations,
            contactName: Values.contactName,
            telephone: Values.telephone,
            email: Values.email,
            creditDays: Values.creditDays,
            deliveDays: Values.deliveDays,
          },
          {
            headers: {
              bussinessId: localStorage.getItem("_bussinessAccountId"),
            },
          }
        )
        .then((result) => {
          return result.data;
        })
        .then((data) => {
          this.loadingD = false;
          this.addProvider = false;
          this.snackbar = true;
          this.color = "success";
          this.text = "Exito al registrar proveedor";
          this.LaodProviders();
        })
        .catch((err) => {
          this.loadingD = false;
          Swal.fire(
            "Error",
            "Ocurrio un error al Registrar al proveedor",
            "error"
          );
          this.loading = false;
        });
    },
    AddProvider() {
      this.addProvider = true;
    },
    Validate() {
      if(this.canEdit){
        this.$v.$touch();
        if (
          this.$v.codigo.required &&
          this.$v.nombre.required &&
          this.$v.ShortName.required &&
          this.$v.ExistMin.required &&
          this.$v.ExistMax.required
        ) {
          this.insumos++;
        }
      }else{
        this.insumos++;
      }
    },
    Receta(val) {
      this.Receta_ = val;
      //console.log(val);
    },
    Guardar() {
      if (this.Receta_.length > 0) {
        let supplieBoms_ = [];
        _.map(this.Receta_, (o) => {
          supplieBoms_.push({
            supplieId: o.id,
            quantity: parseFloat(o.cantidad).toFixed(2),
          });
        });

        this.supplieBoms = supplieBoms_;
      }
      this.$emit("Guardar", {
        code: this.codigo,
        barCode: this.codigoBarras,
        name: this.nombre,
        shortName: this.ShortName,
        providerId: this.ProviderId,
        minimumStock: parseInt(this.ExistMin),
        maximumStock: parseInt(this.ExistMax),
        buyUnitId: this.UnidadC.id,
        stockUnitId: this.UnidadA.id,
        useUnitId: this.UnidadU.id,
        buyToStockFactor: parseInt(this.buyToStockFactor),
        stockToUseFactor: parseInt(this.stockToUseFactor),
        supplieBoms: this.supplieBoms,
        fromSameProvider: this.Swtprov,
        requiresSupplies: this.Swtprep,
      });
    },

    keypressevent($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    onlyForCurrency($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      // only allow number and one dot
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }

      // restrict to 2 decimal places
    },
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    dialog: {
      type: Boolean,
      default: false,
    },
    edited: {
      type: Boolean,
      default: false,
    },
    EditedItem: {
      type: Array,
      default: () => ({
        name: undefined,
      }),
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    codigoBarrasErrors() {
      const errors = [];
      if (!this.$v.codigoBarras.$dirty) return errors;
      return errors;
    },
    UnidadCErrors() {},
    codigoErrors() {
      const errors = [];
      if (!this.$v.codigo.$dirty) return errors;
      !this.$v.codigo.required && errors.push(this.$t("errors.required"));
      return errors;
    },

    nombreErrors() {
      const errors = [];
      if (!this.$v.nombre.$dirty) return errors;
      !this.$v.nombre.required && errors.push(this.$t("errors.required"));
      return errors;
    },
    ShortNameErrors() {
      const errors = [];
      if (!this.$v.ShortName.$dirty) return errors;
      !this.$v.ShortName.required && errors.push(this.$t("errors.required"));
      return errors;
    },
    ExistMinErrors() {
      const errors = [];
      if (!this.$v.ExistMin.$dirty) return errors;
      !this.$v.ExistMin.required && errors.push(this.$t("errors.required"));
      return errors;
    },
    ExistMaxErrors() {
      const errors = [];
      if (!this.$v.ExistMax.$dirty) return errors;
      !this.$v.ExistMax.required && errors.push(this.$t("errors.required"));
      return errors;
    },
    ProviderIdErrors() {
      const errors = [];
      if (!this.$v.ProviderId.$dirty) return errors;
      return errors;
    },

    title() {
      if (this.edited) {
        return "Editar insumo";
      } else {
        return "Dar de alta nuevo insumo";
      }
      //return 'Insumos'
    },

    Mostrar: {
      get: function () {
        if (this.dialog) {
          this.LaodProviders();
          this.LoadUnidades();
          if (this.edited) {
            this.supplieBoms = this.EditedItem[0].supplieBoms;

            this.SupplieId = this.EditedItem[0].id;

            this.codigo = this.EditedItem[0].code;
            this.nombre = this.EditedItem[0].name;

            this.ExistMin = this.EditedItem[0].minimumStock;
            this.ExistMax = this.EditedItem[0].maximumStock;
            this.UnidadC = this.EditedItem[0].buyUnit;

            this.UnidadA = this.EditedItem[0].stockUnit;
            this.UnidadU = this.EditedItem[0].useUnit;
            this.buyToStockFactor = this.EditedItem[0].buyToStockFactor;
            this.stockToUseFactor = this.EditedItem[0].stockToUseFactor;
            this.Swtprov = this.EditedItem[0].fromSameProvider;
            this.Swtprep = this.EditedItem[0].requiresSupplies;
            if (this.EditedItem[0].provider != null) {
              this.ProviderId = this.EditedItem[0].provider.id;
            }
            if (this.EditedItem[0].barCode != null) {
              this.codigoBarras = this.EditedItem[0].barCode;
            }
            //this.UnidadC = 7;
          }
        }
        return this.dialog;
      },
      set: function (val) {
        if (!val) {
          this.$emit("Close");
        }
      },
    },
    _getInsumos: {
      get() {
        return this.$store.state.Insumos;
      },
      set(val) {},
    },
  },
};
</script>
